<template>
  <RevDrawer :name :title="i18n(translations.modalName)">
    <template #body>
      <div class="space-y-24">
        <RevIllustration
          alt="BackUp Header"
          class="w-full"
          :height="150"
          src="/img/insurance/backupModalHeader.svg"
          :width="330"
        />

        <BenefitsTable>
          <template #firstColumnTitle>
            <RevIllustration
              alt="BackUpPlus logo"
              class="inline-block align-middle"
              :height="27"
              src="/img/insurance/backUpLogo.svg"
              :width="80"
            />
          </template>
          <template #secondColumnTitle>
            <div class="text-static-default-hi body-1">
              {{ i18n(translations.warranty) }}
            </div>
          </template>

          <template #rows>
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="true"
              :title="i18n(translations.comparisonTable1)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable2)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable4)"
            />
          </template>
        </BenefitsTable>

        <section v-if="shouldDisplayGoodDeedInformation2" class="space-y-8">
          <header>
            <h2 class="text-static-default-hi heading-3">
              {{ i18n(translations.goodDeedTitle) }}
            </h2>
          </header>
          <div
            class="bg-static-default-low text-static-default-low rounded-lg body-2 space-y-20 p-24"
          >
            <p>
              {{ i18n(translations.goodDeedBody1) }}
            </p>
            <p>
              {{ i18n(translations.goodDeedBody2) }}
            </p>
          </div>
        </section>

        <BackupDrawerFaq />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { MarketCountryCode } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import BackupDrawerFaq from '../BackupDrawerFaq/BackupDrawerFaq.vue'
import BenefitRow from '../components/BenefitRow/BenefitRow.vue'
import BenefitsTable from '../components/BenefitsTable/BenefitsTable.vue'

import translations from './BackupDrawer.translations'

const GOOD_DEED_INFORMATION_2: Record<string, boolean> = {
  [MarketCountryCode.US]: false,
  [MarketCountryCode.GB]: false,
  [MarketCountryCode.JP]: false,
  default: true,
}

defineProps<{ name: string }>()

const i18n = useI18n()
const country = useMarketplace().market.countryCode

const shouldDisplayGoodDeedInformation2 =
  GOOD_DEED_INFORMATION_2[country] ?? GOOD_DEED_INFORMATION_2.default
</script>
